import { useMemo } from 'react';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

export function usePetitionStarterPhoto() {
	const {
		data: {
			petition: { organization, user },
		},
	} = usePetitionDetailsPageData();
	const photo = useMemo(
		() => (organization ? organization.photo?.organizationSmall : user.photo?.userMedium),
		[organization, user],
	);
	const photoUrl = useMemo(() => (photo?.processing ? undefined : photo?.url), [photo]);

	return { photoUrl };
}
